// Хук текущего тарифа + хелперы.
import { type SubscriptionTier, useSessionStore } from "@/stores/session";

interface UseTierResult {
	tier: SubscriptionTier;
	isPaid: boolean;
	isPlus: boolean;
	isPro: boolean;
	isFree: boolean;
	/** Проверка, что текущий тариф >= требуемого. */
	hasTier: (required: SubscriptionTier) => boolean;
}

const RANK: Record<SubscriptionTier, number> = { free: 0, plus: 1, pro: 2 };

export function useTier(): UseTierResult {
	const tier = useSessionStore((s) => s.tier);
	return {
		tier,
		isPaid: tier !== "free",
		isPlus: tier === "plus",
		isPro: tier === "pro",
		isFree: tier === "free",
		hasTier: (required) => RANK[tier] >= RANK[required],
	};
}
